import type { ReactNode } from 'react';

export const EmptyClearIcon = (): ReactNode => {
  return <></>;
};
